import {
  FETCH_USER_DETAILS_REQUEST,
  FETCH_USER_DETAILS_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  RESET_USER_STATE,
} from '../../../redux/types/user';

const initialState = {
  loading: false,
  user: null,
  error: null,
  success: false,
};

const fetchUserDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_DETAILS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: null,
        success: false,
      });

    case FETCH_USER_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        user: action.payload,
        success: true,
      });

    case FETCH_USER_DETAILS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
        success: false,
      });

    case RESET_USER_STATE:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default fetchUserDetailsReducer;
